// extracted by mini-css-extract-plugin
export default {"wrapper":"Skeleton__wrapper--slots-ej7rn","item":"Skeleton__item--slots-TtE7I","horizontalMobile":"Skeleton__horizontalMobile--slots-ClMEF"};